import React, { useState } from "react";

import { StylesProvider } from "@material-ui/core";
import CheckboxSearch, {
  IOptions,
} from "Components/Form/Inputs/CheckboxSearch";

import * as Styled from "./styles";
import { BOLETINS_CATEGORIES } from "Helpers/consts";
import useBoletinsCategories from "Hooks/Boletins/useCategoriesBoletins";

interface Props {
  selected: IOptions[];
  setSelected: React.Dispatch<React.SetStateAction<IOptions[]>>;
}

const Categories: React.FC<Props> = ({ selected, setSelected }) => {
  const { data, isLoading, refetch } = useBoletinsCategories();

  return (
    <Styled.CheckBoxContainer>
      {data && (
        <CheckboxSearch
          hideSearch={true}
          // TODO: removing from this line and put in another function
          options={data.map((current, index) => ({
            id: index,
            name:
              BOLETINS_CATEGORIES[current as keyof typeof BOLETINS_CATEGORIES],
            subvalue: current,
          }))}
          selected={selected}
          setSelected={setSelected}
        />
      )}
    </Styled.CheckBoxContainer>
  );
};
export default Categories;
